import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * Numeric pagination with ellipsis for large page counts.
 * Always shows: first, last, current, current±1.
 */
const Pagination = ({ currentPage, totalPages, onChange }) => {
  if (totalPages <= 1) return null;

  const pages = [];
  const add = (p) => { if (!pages.includes(p)) pages.push(p); };

  add(1);
  for (let p = currentPage - 1; p <= currentPage + 1; p++) {
    if (p > 1 && p < totalPages) add(p);
  }
  if (totalPages > 1) add(totalPages);

  // Insert ellipsis markers ('…') where there's a gap > 1
  const withGaps = [];
  pages.sort((a, b) => a - b).forEach((p, idx, arr) => {
    if (idx > 0 && p - arr[idx - 1] > 1) withGaps.push('…');
    withGaps.push(p);
  });

  return (
    <nav className="flex items-center justify-center gap-1.5 mt-6" aria-label="Sayfa numaraları" data-testid="admin-pagination">
      <Button
        variant="outline"
        size="sm"
        onClick={() => onChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
        data-testid="pagination-prev"
        aria-label="Önceki sayfa"
      >
        <ChevronLeft className="w-4 h-4" />
      </Button>

      {withGaps.map((p, i) =>
        p === '…' ? (
          <span key={`gap-${i}`} className="px-2 text-gray-400 select-none">…</span>
        ) : (
          <Button
            key={`pg-${p}`}
            variant={p === currentPage ? 'default' : 'outline'}
            size="sm"
            className={p === currentPage ? 'bg-[#0F172A] hover:bg-[#1E293B] min-w-[40px]' : 'min-w-[40px]'}
            onClick={() => onChange(p)}
            data-testid={`pagination-page-${p}`}
            aria-current={p === currentPage ? 'page' : undefined}
          >
            {p}
          </Button>
        )
      )}

      <Button
        variant="outline"
        size="sm"
        onClick={() => onChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
        data-testid="pagination-next"
        aria-label="Sonraki sayfa"
      >
        <ChevronRight className="w-4 h-4" />
      </Button>
    </nav>
  );
};

export default Pagination;
